import { getContentfulClient } from './client';
import { unwrapLinkField, resolveAssetUrl } from './utils';

const CONTENT_TYPE = 'openSourceLibraries';

export async function fetchOpenSourceLibraries() {
  const client = getContentfulClient();
  if (!client) {
    return [];
  }

  const limit = 100;
  let skip = 0;
  const rows = [];
  const assetsById = new Map();

  for (;;) {
    const response = await client.getEntries({
      content_type: CONTENT_TYPE,
      limit,
      skip,
      order: 'sys.createdAt',
      include: 10,
    });

    const includedAssets = response.includes?.Asset || response.includes?.asset || [];
    includedAssets.forEach((a) => {
      if (a?.sys?.id) assetsById.set(a.sys.id, a);
    });

    for (const entry of response.items || []) {
      const f = entry.fields || {};
      const name = f.name;
      const link = f.link;
      if (typeof name !== 'string' || typeof link !== 'string') continue;

      const logoUrl = resolveAssetUrl(unwrapLinkField(f.logo), assetsById);

      rows.push({
        contentfulId: entry.sys.id,
        name,
        link,
        logoUrl: logoUrl || null,
      });
    }

    if ((response.items || []).length < limit) break;
    skip += limit;
  }

  return rows;
}
